import React, { useEffect, useState } from "react";

import { useMoralis, useMoralisFile, useMoralisQuery, useMoralisWeb3Api } from "react-moralis";
import {
  Card,
  Image,
  Tooltip,
  Modal,
  Input,
  Alert,
  Spin,
  Button,
  notification,
  Badge,
} from "antd";
import { useNFTBalance } from "hooks/useNFTBalance";
import { FileSearchOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { useMoralisDapp } from "contexts/MoralisDappProvider/MoralisDappProvider";
import { getExplorer } from "helpers/networks";
import { useWeb3ExecuteFunction } from "react-moralis";
import { Col, Container, DropdownButton, Row, Button as B } from "react-bootstrap";
import HelmetMetaData from "components/HelmetMetaData";
import { Dropdown } from "bootstrap";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import runCombine from "components/Combine/combine";
import runCombineInshon from "components/Combine/combineInshon";
import { useNFTTokenIds } from "hooks/useNFTTokenIds";

const { Meta } = Card;

const styles = {
  NFTs: {
    display: "flex",
    flexWrap: "wrap",
    WebkitBoxPack: "start",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "1000px",
    gap: "10px",
  },
  selector: {
    color: "black",
    backgroundColor: "white",
  },
};

function NFTBalance() {
  const { NFTBalance, fetchSuccess } = useNFTBalance();
  const { chainId, marketAddress, contractABI, ieduABI, ieduAddress, nftAddress } =
    useMoralisDapp();
  const { Moralis } = useMoralis();
  const [visible, setVisibility] = useState(false);
  const [nftToSend, setNftToSend] = useState(null);
  const [price, setPrice] = useState(1);
  const [loading, setLoading] = useState(false);

  const [nftIDs, setNftIDs] = useState([]);
  const [combineVis, setCombineVis] = useState(false);
  const [idLoaded, setIdLoaded] = useState(false);
  const [uploadIPFS, setUploadIPFS] = useState(false);
  const [search, setSearch] = useState("");

  const queryMintedItems = useMoralisQuery("CreatedMintRequest");
  const fetchMintedItems = JSON.parse(
    JSON.stringify(queryMintedItems.data, [
      "updatedAt",
      "minted",
      "nftContract",
      "itemId",
      "ipfsURI"
    ])
  )
    .filter(
      (item) => item.minted === false
    );

  const contractProcessor = useWeb3ExecuteFunction();
  const contractABIJson = JSON.parse(contractABI);
  const ieduABIJson = JSON.parse(ieduABI);
  const listItemFunction = "createMarketItemERC20";
  const ItemImage = Moralis.Object.extend("ItemImages");

  async function list(nft, listPrice) {
    setLoading(true);
    const p = listPrice * ("1e" + 18);
    const ops = {
      contractAddress: marketAddress,
      functionName: listItemFunction,
      abi: contractABIJson,
      params: {
        nftContract: nft.token_address,
        tokenId: nft.token_id,
        price: listPrice,
      },
    };

    await contractProcessor.fetch({
      params: ops,
      onSuccess: () => {
        console.log("success");
        setLoading(false);
        setVisibility(false);
        addItemImage();
        succList();
        openNotification();
      },
      onError: (error) => {
        setLoading(false);
        failList();
      },
    });
  }

  async function approveAll(nft) {
    setLoading(true);
    const ops = {
      contractAddress: nft.token_address,
      functionName: "setApprovalForAll",
      abi: [
        {
          inputs: [
            { internalType: "address", name: "operator", type: "address" },
            { internalType: "bool", name: "approved", type: "bool" },
          ],
          name: "setApprovalForAll",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      params: {
        operator: marketAddress,
        approved: true,
      },
    };

    await contractProcessor.fetch({
      params: ops,
      onSuccess: () => {
        console.log("Approval Received");
        setLoading(false);
        setVisibility(false);
        succApprove();
      },
      onError: (error) => {
        setLoading(false);
        failApprove();
      },
    });
  }

  const handleSellClick = (nft) => {
    setNftToSend(nft);
    setVisibility(true);
  };

  function succList() {
    let secondsToGo = 5;
    const modal = Modal.success({
      title: "Success!",
      content: `Your NFT was listed on the marketplace`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function succApprove() {
    let secondsToGo = 5;
    const modal = Modal.success({
      title: "Success!",
      content: `Approval is now set, you may list your NFT`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function failList() {
    let secondsToGo = 5;
    const modal = Modal.error({
      title: "Error!",
      content: `There was a problem listing your NFT`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function failApprove() {
    let secondsToGo = 5;
    const modal = Modal.error({
      title: "Error!",
      content: `There was a problem with setting approval`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  function addItemImage() {
    const itemImage = new ItemImage();

    itemImage.set("image", nftToSend.image);
    itemImage.set("nftContract", nftToSend.token_address);
    itemImage.set("tokenId", nftToSend.token_id);
    itemImage.set("name", nftToSend.name);

    itemImage.save();
  }
  const openNotification = () => {
    notification.open({
      message: "NFT Sale Pending",
      description:
        "Your NFT has been put up for sale, there is a waiting period of up to 20 minutes.",
      onClick: () => {
        console.log("Notification Clicked!");
      },
    });
  };

  const [combineNFT1, setCombineNFT1] = useState("");
  const [combineNFT2, setCombineNFT2] = useState("");
  function selectNFT(e, setFunc) {
    console.log("select", e);
    setFunc(e);
  }

  //all variables for combining NFTs
  const [ipfsHash, setIpfsHash] = useState("");
  const [ipfsImg, setIpfsImg] = useState("");
  const [imgData, setImgData] = useState("");
  const [imgMetadata, setImgMetadata] = useState();
  const [imgDataIpfs, setImgDataIpfs] = useState("");
  const { totalNFTs } = useNFTTokenIds(chainId, nftAddress);
  const web3api = useMoralisWeb3Api();
  const aws = require("../../helpers/mailses");
  const mintCost = "10";

  //function to upload image data to ipfs via moralis API
  async function moralisUpload(_encodedGif) {
    const options = {
      abi: [
        {
          path: `images/${parseInt(totalNFTs) + fetchMintedItems.length}.gif`,
          content: _encodedGif
        },
      ],
    };
    const fileIpfs = await web3api.storage.uploadFolder(options);
    console.log("path", fileIpfs[0].path)
    console.log(fileIpfs[0].path.replace("https://ipfs.moralis.io:2053/ipfs/", "ipfs://"));
    setIpfsImg(fileIpfs[0].path);
    setImgDataIpfs(fileIpfs[0].path.replace("https://ipfs.moralis.io:2053/ipfs/", "ipfs://"));
  }

  //function to upload NFT metadata to ipfs via moralis
  async function moralisUploadMetadata(_imgPath) {
    const options = {
      abi: [
        {
          path: `metadata/${parseInt(totalNFTs) + fetchMintedItems.length}.json`,
          content: {
            image: _imgPath,
            tokenId: parseInt(totalNFTs) + fetchMintedItems.length,
            name: imgMetadata.name,
            parent1: imgMetadata.parent1_id,
            parent2: imgMetadata.parent2_id,
            attributes: imgMetadata.attributes
          }
        },
      ],
    };
    const metaIpfs = await web3api.storage.uploadFolder(options);
    console.log(metaIpfs[0].path);
    setIpfsHash(metaIpfs[0].path.replace("https://ipfs.moralis.io:2053/ipfs/", ""));
  }

  async function combineRun() {
    if (combineNFT1 !== "" && combineNFT2 !== "") {
      setUploadIPFS(true);
      console.log(uploadIPFS);
      if (chainId == "0x89") {
        console.log(chainId, true, fetchMintedItems);
        console.log(await runCombineInshon(combineNFT1, combineNFT2, parseInt(totalNFTs) + fetchMintedItems.length, setImgMetadata, setImgData));
      } else {
        console.log(await runCombine(combineNFT1, combineNFT2, parseInt(totalNFTs) + fetchMintedItems.length , setImgMetadata, setImgData));
      }
    }
  }

  async function mintRequest(nft) {
    setUploadIPFS(true);
    const ops = {
      contractAddress: marketAddress,
      functionName: "createMintRequest",
      abi: contractABIJson,
      params: {
        nftContract: nftAddress,
        //set ieduPrice to a arbitrary value for users to access this function
        ieduPrice: mintCost,
        uri: ipfsHash,
        //token = token contract address
        token: ieduAddress,
        //ieduTo = address to send iedu to, in most cases just send it to the owner of IEDU
        ieduTo: "0x8Fa61fed6AE280C460724a3c6CFdc1A7eB86adb5"
      },
    };

    await contractProcessor.fetch({
      params: ops,
      onSuccess: () => {
        console.log("success for nft: ", ipfsHash.substring(ipfsHash.split("/", 2).join("/").length + 1).replace(".json", ""));
        setUploadIPFS(false);
        setCombineVis(false);
        sendEmail(ipfsHash.substring(ipfsHash.split("/", 2).join("/").length + 1).replace(".json", ""));
        mintReqested();
      },
      onError: (error) => {
        setLoading(false);
        setUploadIPFS(false);
        setCombineVis(false);
        failList();
      },
    });
  }

  function mintReqested() {
    let secondsToGo = 5;
    const modal = Modal.success({
      title: "Requested!",
      content: `Your NFT mint request has been sent to the admins, please wait for them to approve and mint your NFT.`,
    });
    setTimeout(() => {
      modal.destroy();
    }, secondsToGo * 1000);
  }

  const sendEmail = (nftId) => {
    aws.sendMintRequestEmail(nftId);
  }

  useEffect(() => {
    let tempList = [];
    for (let i = 0; i < NFTBalance.length; i++) {
      tempList.push(NFTBalance[i].token_id);
    }
    setNftIDs(tempList);
  }, [NFTBalance])

  useEffect(() => {
    if (nftIDs.length > 0) {
      nftIDs.sort((a, b) =>
        parseInt(a) - parseInt(b)
      );
      setIdLoaded(true);
    }
  }, [nftIDs])

  useEffect(() => {
    setUploadIPFS(false);
  }, [ipfsHash])

  useEffect(() => {
    if (imgData !== "") {
      moralisUpload(imgData);
    }
  }, [imgData])

  useEffect(() => {
    if (imgDataIpfs !== "") {
      moralisUploadMetadata(imgDataIpfs);
    }
  }, [imgDataIpfs])

  return (
    <Container>
      <HelmetMetaData
        title="Marketplace - Collection | Innov-Edu"
        description="Check on the Innov-Edu NFTs that you own on this page."
      ></HelmetMetaData>
      <h1 style={{ textAlign: "center" }}>Your NFTs</h1>
      <p style={{ textAlign: "center", margin: "1em auto", width: "75%" }}>Here are the NFTs that you have collected from Innov-Edu, all of your owned NFTs are on display and can be listed for sale to earn and exchange IEDU tokens.
        you can also access features like generating a new NFT from two currently existing NFTs that you own and sedning a request to an admin to have that NFT minted.</p>
      <div>
        {contractABIJson.noContractDeployed && (
          <>
            <Alert
              message="No Smart Contract Details Provided. Please deploy smart contract and provide address + ABI in the MoralisDappProvider.js file"
              type="error"
            />
            <div style={{ marginBottom: "10px" }}></div>
          </>
        )}
        {!fetchSuccess && (
          <>
            <Alert
              message="Unable to fetch all NFT metadata... We are searching for a solution, please try again later!"
              type="warning"
            />
            <div style={{ marginBottom: "10px" }}></div>
          </>
        )}
        {/* {console.log(NFTBalance)} */}
        {NFTBalance &&
          <div>
            <hr />

            <div className="collections-options">
              <Input
                autoFocus
                placeholder="Search NFT by Name or Token ID"
                onChange={(e) => setSearch(e.target.value)}
                className="collections-search"
              />
              <Button onClick={() => setCombineVis(true)}>Combine</Button>
            </div>

            <div style={styles.NFTs}>
              {NFTBalance.filter(item => (item["metadata"]?.name.includes(search)) || item.token_id === search).map((nft, index) => {
                // addNftID();
                return (
                  <Card
                    hoverable
                    actions={[
                      <Tooltip title="View On Blockexplorer">
                        <FileSearchOutlined
                          onClick={() =>
                            window.open(
                              `${getExplorer(chainId)}address/${nft.token_address}`,
                              "_blank"
                            )
                          }
                        />
                      </Tooltip>,
                      <Tooltip title="List NFT for sale">
                        <ShoppingCartOutlined
                          onClick={() => handleSellClick(nft)}
                        />
                      </Tooltip>,
                    ]}
                    style={{ width: 240, border: "2px solid #e7eaf3" }}
                    cover={
                      <Image
                        preview={false}
                        src={nft?.image || "error"}
                        fallback="data:image/png;base64,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"
                        alt=""
                        style={{ height: "240px" }}
                      />
                    }
                    key={index}
                  >
                    <Meta title={nft.metadata.name} description={nft.symbol} />
                  </Card>
                );
              })
              }

            </div>
          </div>
        }
      </div>

      <Modal
        title={`List ${nftToSend?.name} #${nftToSend?.token_id} For Sale`}
        visible={visible}
        onCancel={() => setVisibility(false)}
        onOk={() => list(nftToSend, price)}
        okText="List"
        footer={[
          <Button onClick={() => setVisibility(false)}>Cancel</Button>,
          <Button onClick={() => approveAll(nftToSend)} type="primary">
            Approve
          </Button>,
          <Button onClick={() => list(nftToSend, price)} type="primary">
            List
          </Button>,
        ]}
      >
        <Spin spinning={loading}>
          <img
            src={`${nftToSend?.image}`}
            style={{
              width: "250px",
              margin: "auto",
              borderRadius: "10px",
              marginBottom: "15px",
            }}
          />
          <Input
            autoFocus
            placeholder="Listing Price in IEDU"
            onChange={(e) => setPrice(e.target.value)}
          />
        </Spin>
      </Modal>

      <Modal
        title="Combine Two NFTs to create a new one!"
        visible={combineVis}
        onCancel={() => setCombineVis(false)}
        // bodyStyle={{ height: "40vh" }}
        // onOk={() => list(nftToSend, price)}
        // okText="List"
        footer={[
          <Button key="1" onClick={() => setCombineVis(false)}>Cancel</Button>,
          <Button key="2" disabled={combineNFT1 === "" || combineNFT2 === ""} onClick={() => combineRun()}>Combine NFT!</Button>,
        ]}
      >
        <Spin spinning={uploadIPFS} tip="Processing your request, it may take a minute...">
          {idLoaded ?
            <>
              <Row>
                <Col>
                  <img
                    src={combineNFT1 !== "" ? NFTBalance.find(({ token_id }) => token_id === combineNFT1)["image"] : null}
                    style={{
                      width: "250px",
                      margin: "auto",
                    }}
                  />
                  <DropdownButton
                    key="button"
                    id="dropdown-menu-align-right"
                    title={combineNFT1 === "" ? "First NFT" : combineNFT1}
                    onSelect={(e) => {
                      selectNFT(e, setCombineNFT1);
                    }}
                  >
                    {nftIDs.map((id, i) => {
                      if (id !== combineNFT2) {
                        return (
                          <DropdownItem eventKey={id}>{id}</DropdownItem>
                        )
                      }
                    })}
                  </DropdownButton>

                  <hr />
                  {combineNFT1 !== "" ? <h4>{NFTBalance.find(({ token_id }) => token_id === combineNFT1)["metadata"]["name"]}</h4> : null}
                </Col>
                {
                  combineNFT1 !== "" ?
                    <Col>
                      <img
                        src={combineNFT2 !== "" ? NFTBalance.find(({ token_id }) => token_id === combineNFT2)["image"] : null}
                        style={{
                          width: "250px",
                          margin: "auto",
                        }}
                      />
                      <DropdownButton
                        key="button2"
                        id="dropdown-menu-align-right"
                        title={combineNFT2 === "" ? "Second NFT" : combineNFT2}
                        onSelect={(e) => {
                          selectNFT(e, setCombineNFT2);
                        }}
                      >
                        {nftIDs.map((id, i) => {
                          if (id !== combineNFT1) {
                            return (
                              <DropdownItem eventKey={id}>{id}</DropdownItem>
                            )
                          }
                        })}
                      </DropdownButton>
                      {/* <h4><br />Second Selected<br />NFT: {combineNFT2}</h4> */}


                      <hr />
                      {combineNFT2 !== "" ? <h4>{NFTBalance.find(({ token_id }) => token_id === combineNFT2)["metadata"]["name"]}</h4> : null}
                      {/* <h4>{console.log(NFTBalance)}{NFTBalance.find(({ token_id }) => token_id === combineNFT2)["metadata"]["name"]}</h4> */}
                    </Col>
                    : null
                }

                <hr style={{ marginTop: "30px", width: "95%" }} />
                {
                  ipfsImg !== "" ?
                    <>
                      <br />
                      <h3>Results</h3>
                      <Row>
                        <Col xs={6}>
                          <Badge.Ribbon
                            color="green"
                            text={`${mintCost} IEDU to Mint`}
                          >
                            <img
                              src={ipfsImg !== "" ? ipfsImg : null}
                              style={{
                                // width: "250px",
                                margin: "auto",
                                // borderRadius: "10px",
                                marginBottom: "0px",
                                padding: "0",
                              }}
                            />
                          </Badge.Ribbon>
                          <Button key="3" style={{ width: "100%" }} disabled={ipfsHash === ""} onClick={() => mintRequest()}>Request Mint!</Button>
                        </Col>
                        <Col xs={6}>
                          <h5>{imgMetadata.name}</h5>
                          <hr style={{ margin: "0" }} />
                          <p style={{ fontSize: "18px" }}>Attributes: </p>
                          <div>
                            <p>Parent 1: {imgMetadata.parent1_id}, Parent 2: {imgMetadata.parent2_id}</p>
                            {imgMetadata.attributes.map((e) => {
                              return (
                                <p>
                                  {e.trait_type} - {e.name ? e.name : e.value}
                                </p>
                              );
                            })}
                          </div>
                        </Col>
                      </Row>
                    </>
                    : null
                }

              </Row>


            </>
            : null}
        </Spin>
      </Modal>
    </Container >
  );
}

export default NFTBalance;
